import { render, staticRenderFns } from "./dealerpersons.vue?vue&type=template&id=b117b60c&"
import script from "./dealerpersons.vue?vue&type=script&lang=js&"
export * from "./dealerpersons.vue?vue&type=script&lang=js&"
import style0 from "./dealerpersons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports